import * as Sentry from "@sentry/react";

import { APP_ENV, APP_VERSION } from "@src/env";

Sentry.init({
  dsn: "https://ec76546561517f1e72ced808ae3614fb@o945999.ingest.us.sentry.io/4510387907198977",
  sendDefaultPii: true,
  release: APP_VERSION,
  environment: APP_ENV,
  integrations: [],
});

export const captureException = Sentry.captureException;
export const captureMessage = Sentry.captureMessage;
